module.exports = __webpack_public_path__ + "static/media/what_is_codecache.892820a8.svg";